
import Vue from 'vue'

const transformer = ({ quantificationSupply, supplyReplacementId }) => ({
  original_supply: quantificationSupply,
  replace_with: supplyReplacementId
})

export default (payload) =>
  Vue.$http.post('purchase/quantification/replace-supplies/', transformer(payload))
    .then(response => response.data)


// WEBPACK FOOTER //
// ./src/services/purchase/replaceSupplies.js